import { Box, FormControlLabel, Grid, Switch, TextField } from "@mui/material"
import { useApi } from "auth/useApi3"
import { apiEndpoints } from "generated/apiEndpoints"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { PasswordSuggestion } from "./PasswordSuggestion"

export const UsernameField = ({
  values,
  setFieldValue,
  handleBlur,
  handleChange,
  touched,
  errors,
  passwordSuggestEndpoint
}) => {
  const { t } = useTranslation()
  const [userResult, userApi] = useApi()
  const [userByEmailResult, userByEmailApi] = useApi()

  const fetchAzureB2CUser = (searchTerm) => {
    userApi.get(apiEndpoints.customeradmin.getaduser.replace("{searchTerm}", searchTerm))
  }

  const emailExistInTP = (email) => {
    userByEmailApi.get(apiEndpoints.customeradmin.getuserbyemail.replace("{email}", email))
  }

  useEffect(() => {
    if (userResult.status === 2) {
      setFieldValue("hasAdUserAlready", userResult.data.status === "UserExistsInAd")
      setFieldValue(
        "userExists",
        userResult.data.status === "UserExistsInTPAndAd" || userResult.data.status === "UserExistsInTP"
          ? true
          : false
      )
    }
  }, [userResult, setFieldValue])

  useEffect(() => {
    if (errors.email || values.email === "" || values.email == null) {
      setFieldValue("sendEmailOnCreate", false)
    }
  }, [errors.email, values.email, values.useUsername, setFieldValue])

  useEffect(() => {
    if (userByEmailResult.status !== 2) return
    setFieldValue("emailTaken", userByEmailResult.data.status === "UserExistsInTP")
  }, [userByEmailResult])

  return (
    <>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Switch
              onChange={(event) => {
                handleChange(event)
                if (event.target.checked) {
                  setFieldValue("email", "")
                } else {
                  setFieldValue("email", values.username)
                }
              }}
              id="useUsername"
              checked={values.useUsername}
            />
          }
          label={t("settings.user.register_user_without_email", "Register users without email")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          autoComplete="off"
          fullWidth
          id={"username"}
          label={t(values.useUsername ? `settings.user.username` : `settings.user.email`, ``)}
          value={values.username}
          onChange={(event) => {
            handleChange(event)
            if (!values.useUsername) {
              setFieldValue("email", event.target.value)
            }
          }}
          onBlur={(e) => {
            handleBlur(e)
            fetchAzureB2CUser(values.username)
          }}
          error={touched.username && errors.username ? true : false}
          helperText={touched.username && errors.username ? errors.username : null}
          variant="outlined"
        />
      </Grid>
      {values.useUsername && (
        <Grid item xs={12}>
          <TextField
            autoComplete="off"
            fullWidth
            id="email"
            name="email"
            label={t(`settings.user.optionalEmail`, `Optional e-mail`)}
            value={values.email}
            onChange={handleChange}
            onBlur={(e) => {
              handleBlur(e)
              fetchAzureB2CUser(values.email)
              emailExistInTP(values.email)
            }}
            error={touched.email && errors.email ? true : false}
            helperText={touched.email && errors.email ? errors.email : null}
            variant="outlined"
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <div hidden={values.userExists || values.hasAdUserAlready}>
          <PasswordSuggestion
            values={values}
            setFieldValue={setFieldValue}
            passwordSuggestEndpoint={passwordSuggestEndpoint}
          />
        </div>

        {userResult.data?.status === "UserExistsInAd" && (
          <Box
            my={2}
            padding={3}
            bgcolor="background.default"
            width={1}
            border={1}
            borderColor="primary.main"
            color="primary.dark"
            borderRadius="2px">
            {t(
              "settings.user.the_user_already_exsists",
              "User already exists as a customer before, you need to create it in your organization but it will retain the existing password."
            )}
          </Box>
        )}

        {userResult.data?.status === "UserExistsInTP" ||
          (userResult.data?.status === "UserExistsInTPAndAd" && (
            <Box
              my={2}
              padding={3}
              bgcolor="error.light"
              width={1}
              border={1}
              borderColor="error.main"
              color="error.dark"
              borderRadius="2px">
              {t(
                "settings.user.username_already_exists",
                "The username already exists. Contact support if the user needs to be moved."
              )}
            </Box>
          ))}
        {userByEmailResult.data?.status === "UserExistsInTP" && (
          <Box
            my={2}
            padding={3}
            bgcolor="error.light"
            width={1}
            border={1}
            borderColor="error.main"
            color="error.dark"
            borderRadius={2}>
            {t(
              "settings.user.emailTakenContactSupport",
              "E-posten finns redan registrerad. Kontakta support om användaren ska flyttas"
            )}
          </Box>
        )}
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Switch
              onChange={handleChange}
              id="sendEmailOnCreate"
              checked={values.sendEmailOnCreate}
              disabled={values.useUsername && (values.email === "" || values.email == null || errors.email)}
            />
          }
          label={t("settings.user.send_email_with_login_details", "Send email with login details")}
        />
      </Grid>
    </>
  )
}
